import moment from 'moment'
import React, { useMemo } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { CollaborationItem, Milestone } from 'types/campaign/collaborations'
import userProfilePicture from "../../../assets/images/users/user-dummy-img.jpg"

interface CollaborationListItemProps {
    collaboration: CollaborationItem,
    isSelected?: boolean
}

const CollaborationListItem: React.FC<CollaborationListItemProps> = ({ collaboration, isSelected }) => {

    const { campaignId } = useParams();
    const [searchParams] = useSearchParams();
    const filtersQuery = searchParams.get('filters');

    const { actionRequiredStep, actionPendingFromInfluencerStep } = useMemo(() => {

        const activeSteps = Array.isArray(collaboration?.active_steps) ? collaboration.active_steps : [];

        const brandSteps = activeSteps.filter((step) => step.can_process).sort((a, b) => a.sort_order - b.sort_order);
        if (brandSteps.length > 0) {
            return { actionRequiredStep: brandSteps[0] }
        }

        const influencerSteps = activeSteps.filter((step) => !step.can_process).sort((a, b) => a.sort_order - b.sort_order);

        if (influencerSteps.length > 0) {
            return { actionPendingFromInfluencerStep: influencerSteps[0] }
        }

        return { actionRequiredStep: null, actionPendingFromInfluencerStep: null };
    }, [collaboration])

    const getMilestoneName = (milestone: Milestone) => {
        return `${collaboration.milestones_count > 1 ? `#${milestone?.sort_order} ` : ''}${milestone?.gig_type?.name}`
    }

    return (
        <Link to={{ pathname: collaboration.active_milestone ? `/collaboration/campaign/${collaboration.campaign.uuid}/collaboration/${collaboration.influencer.uuid}/milestone/${collaboration.active_milestone?.id}` : `/collaboration/campaign/${collaboration.campaign.uuid}/collaboration/${collaboration.influencer.uuid}`, search: filtersQuery ? `?filters=${filtersQuery}` : '' }} className={`collaboration-list-item-wrapper ${isSelected ? 'selected' : ''}`}>
            <div className={`collaboration-list-item z-1 position-relative ${isSelected ? 'selected' : ''}`}>
                <div className="collaboration-item-left">
                    <div className="collaborator-pic">
                        <img src={collaboration.influencer?.social_account?.profile_picture_url ?? userProfilePicture} className='collaborator-profile-pic' />
                    </div>
                    <div className="collaborator-data">
                        <span className="collaborator-name">{collaboration.influencer.name}</span>
                        <span className='current-step-details'>

                            {
                                actionRequiredStep ? (
                                    <span className='pending-from-brand'>
                                        <span className="current-step-label">Action Needed: </span>
                                        <span className="current-step-action">{actionRequiredStep.gig_step.title ?? actionRequiredStep.gig_step.name}</span>
                                    </span>
                                ) : (
                                    actionPendingFromInfluencerStep ? (
                                        <span className='pending-from-influencer'>
                                            <span className="current-step-label">Waiting for: </span>
                                            <span className="current-step-action">{actionPendingFromInfluencerStep.gig_step.title ?? actionPendingFromInfluencerStep.gig_step.name}</span>
                                        </span>
                                    ) : ''
                                )
                            }
                        </span>
                        <span className="milestone-name">
                            {collaboration.campaign?.name}
                        </span>
                    </div>
                </div>

                {/* <div className="collaboration-item-right">
                    {
                        collaboration.active_milestone &&
                        <span className='milestone-number'>{getMilestoneName(collaboration.active_milestone)}</span>
                    }
                </div> */}
            </div>
            {
                actionPendingFromInfluencerStep?.deadline &&
                <div className={`deadline mt-n4 z-0 ${isSelected ? 'selected' : ''}`}>
                    Expected Delivery Date: {moment.utc(actionPendingFromInfluencerStep.deadline).local().format('MMM DD, hh:mm A')}
                </div>
            }
        </Link>

    )
}

export default CollaborationListItem